import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import Layout from '@/container/Layout';
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { HotlineProFirstReplyCompleteView } from '@/feature/hotline/professional/firstReply/complete/page/HotlineProFirstReplyCompleteView';
import { useHotlineProFirstReplyFormContext } from '@/feature/hotline/professional/firstReply/context/HotlineProFirstReplyFormContext';
import { pagePath } from '@/utils/router/pagePath';
/**
 * ホットライン 初回返信 完了画面（ロジック部分のみ）
 * @description api データ取得, その他ロジック部分
 */
export const HotlineProFirstReplyCompletePage = (props) => {
    const { id, title } = props;
    const { setFormValues } = useHotlineProFirstReplyFormContext();
    useEffect(() => {
        // フォームの状態をリセット
        setFormValues(null);
    }, [setFormValues]);
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { relativePath: pagePath.hotline.professional.firstReplyComplete(id), title: `${title} 初回返信 - 完了 | PROFFIT` }), _jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineProFirstReplyCompleteView, { id: id, title: title }) }))] }));
};
